import type { PolicyMetaData } from "@/core/types";
import { publicRequestsTyped } from "@/api/(requests)/publicTyped";

export async function getPolicyMetadata(): Promise<PolicyMetaData> {
  return publicRequestsTyped.get_policy_metadata();
}
